import React from "react"

export default function Footer() {
    return(
        <div className="footer">
            <h3>Prod. best buddies</h3>
        </div>
    )
}